import React from "react";
import './Hero.css';
import banner1 from '../assets/images/Slides/gallery01.jpg';




    
const Hero = () => {

    return(
        <>
            <div className="hero" id="hero">
                <h1>Delta Tank GmbH</h1>
                <h2>Professionelle Tankreinigungs- und Korrosionsschutzdienste</h2>
            </div>
            <div><br /></div>
        </>
    );
};

export default Hero;